import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'

export default class Salesmen extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        currentUrl: null
    }

    componentDidMount = () => {
        let url = window.location.href;
        this.checkUrl(url);
    }

    checkUrl = (url) => {
        this.setState({ currentUrl: url })
    }

    render() {
        const {
            item
        } = this.props

        const {
            currentUrl
        } = this.state
        return (
            <Wrapper fluid>
                <InsideWrapper>
                    <Menu>
                        {item.map((a, index) =>
                            <Submenu key={index} to={getRelativeUrl(a.url.link)} activebutton={currentUrl === a.url.link ? 'true' : 'false'}>{a.text}</Submenu>
                        )}
                    </Menu>
                </InsideWrapper>
            </Wrapper >
        )
    }
}

//Styles
const Wrapper = styled(Container)`
${media.lg`
padding: 0 20%;
`}
`
const InsideWrapper = styled.div`
width: 100%;
`
const Menu = styled.nav`
width: 100%;
background-color: white;
display: inline-flex;
justify-content: space-around;
border-radius: 50px;
box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
margin-bottom: 20px;
text-transform: uppercase;
color: #004077;
cursor: pointer;
align-items: stretch;
margin-top: 2em;
${media.lg`
    margin-top: 1em;
`}
`
const Submenu = styled(Link)`
${media.lg`
padding: 20px;
`}
padding: 10px;
width: 100%;
border-radius: 50px;
text-align: center;
text-decoration: none;
color: ${props => props.activebutton === 'true' ? 'white' : '#004077'};
background-color: ${props => props.activebutton === 'true' ? '#004077' : 'white'}
display: flex;
align-items: center;
justify-content: center;

:hover{
    background-color: #004077;
    color: white;
}
`




// WEBPACK FOOTER //
// ./src/ui/components/modules/ContactMenu/index.js